import {Draggable, gsap, InertiaPlugin} from "gsap/all";
import $ from "jquery";
import {LevelWithCamera} from "./LevelWithCamera";
import nunjucks from "nunjucks";
import {ThreeJSCameraOverlay} from "./ThreeJSCameraOverlay";
import {Quiz} from "./Quiz";
// import {GSDevTools} from "gsap/GSDevTools";

// gsap.registerPlugin(GSDevTools)

export class Level2 extends LevelWithCamera {

  constructor({cameraFeed, visionEngine}) {
    super(cameraFeed, $("#screen-2-LEVEL2 .camera-canvas").get(0), visionEngine);
    // console.log("constructor level2 with cam")

    this.$screen = $("#screen-2-LEVEL2");

    this.quiz = new Quiz(this, this.$screen.find(".quiz-container"));

    this.currentStep = 1;

    this.step1Timeout = null
    this.step1Delay = 1000; // ms before continuing after last step

    this.step2Timeout = null
    this.step2Delay = 200; // ms before continuing after last step

    this.listenForPinchZoomIn = false;
    this.listenForPinchZoomOut = false;

    this.lottieHandZoomIn = this.$screen.find(".hand-zoom-in-animation .lottie-animation").data('lottie');
    this.lottieHandZoomOut = this.$screen.find(".hand-zoom-out-animation .lottie-animation").data('lottie');
    this.lottieDiscoverMoreOverlay = this.$screen.find(".discover-more-overlay .lottie-animation").data('lottie');
    this.lottieDiscoverMoreButtons = {
      fr: this.$screen.find(".discover-more-button-fr .lottie-animation").data('lottie'),
      en: this.$screen.find(".discover-more-button-en .lottie-animation").data('lottie')
    };

    this.zoomTimeline = null;
    this.transitionTimeline = null;

    this.enableCameraOverlay = false;

    this.started = false;
    this.locked = false;

    this.init();
  }

  init() {
    // console.log("init level 2")
    super.init();

    $(document).on('pinchout', (e, data) => this.onPinchOut(e, data));
    $(document).on('pinchin', (e, data) => this.onPinchIn(e, data));
  }

  start() {

    this.startCamera();
    // NOTE: We start at step 2 as we now skip the camera at the beginning
    this.goToStep(2);

    // For debugging:
    // this.goToStep(2);

    this.started = true;
  }

  goToStep(stepId) {
    // TODO: This is only a basic temp transition between screens. We need to handle this correctly with timelines

    this.$screen.find(`.step`).removeClass("active");
    this.hideHandZoomAnimation();
    this.lottieDiscoverMoreButtons.fr.pause(0);
    this.lottieDiscoverMoreButtons.en.pause(0);

    // We can also handle each step custom transitions here if needed
    if (stepId === 2) {
      this.$screen.find(`.step-2`).removeClass("quiz-active");
      this.lottieDiscoverMoreOverlay.play(0);

      this.transitionTimeline = gsap.timeline({
        onComplete: () => {
          this.$screen.find(`.step-${stepId}`).addClass("active");
          this.lottieDiscoverMoreButtons[app.i18n.lang].play(0);

          // Prepare the camera for later
          this.showCamera();
        }
      });

      this.transitionTimeline.to(this.$screen.find(`.step-${this.currentStep}`), {
        autoAlpha: 0
      });

      this.transitionTimeline.add(() => {
        this.currentStep = stepId;
        this.initStep();
      });

      this.transitionTimeline.fromTo(this.$screen.find(`.step-2`),
        {
          autoAlpha: 0,
        },
        {
          autoAlpha: 1
        });

      this.transitionTimeline.fromTo(this.$screen.find(`.step-2 .questions-container .question`),
        {
          scale: 0,
          autoAlpha: 0,
        },
        {
          scale: 1,
          autoAlpha: 1,
          ease: "back.out",
          stagger: 0.1
        },
        "-=0.5");

      this.transitionTimeline.fromTo(this.$screen.find(`.step-2 .animation-overlay img`),
        {
          autoAlpha: 0,
        },
        {
          autoAlpha: 1
        });

      this.transitionTimeline.fromTo(this.$screen.find(`.step-2 .text-bubble.introduction`),
        {
          autoAlpha: 0,
        },
        {
          autoAlpha: 1
        });

      this.transitionTimeline.fromTo(this.$screen.find(`.step-2 .animation-overlay canvas`),
        {
          autoAlpha: 0,
        },
        {
          autoAlpha: 1
        });

      this.transitionTimeline.fromTo(this.$screen.find(`.step-2 .actions-container`),
        {
          scale: 0.5,
          autoAlpha: 0,
        },
        {
          scale: 1,
          autoAlpha: 1,
          ease: "back.out(1.7)",
        }, `+=${this.step2Delay / 1000}`)

      this.$screen.find(`.step-2 .actions-container`).removeClass("hidden");

    } else {

      this.transitionTimeline = gsap.timeline({
        onComplete: () => {
          this.$screen.find(`.step-${stepId}`).addClass("active");
        }
      });

      this.transitionTimeline.to(this.$screen.find(`.step-${this.currentStep}`), {
        autoAlpha: 0
      });

      this.transitionTimeline.add(() => {
        this.currentStep = stepId;
        this.initStep();
      });

      this.transitionTimeline.to(this.$screen.find(`.step-${stepId}`), {
        autoAlpha: 1
      });
    }
  }

  nextStep() {
    this.goToStep(this.currentStep + 1);
  }

  initStep() {
    if (this.currentStep === 1) {

      // NOTE: This is not used anymore as step 1 is skipped.
      // We keep the code here in case we want to add something at step 1
      if (this.step1Timeout !== null) {
        clearTimeout(this.step1Timeout);
        this.step1Timeout = null;
      }

      this.step1Timeout = setTimeout(() => {
        this.nextStep();
      }, this.step1Delay)

    } else if (this.currentStep === 2) {

    }
  }

  startQuiz() {

    app.audio.play("audio/MNS2_Communs_SFX/MNS2_ME_INT_SFXselection.mp3", 1, true)

    this.$screen.find(`.step-2 .actions-container`).addClass("hidden");

    this.transitionTimeline = gsap.timeline({
      onComplete: () => {
        this.$screen.find(`.step-2`).addClass("quiz-active");
        this.lottieDiscoverMoreOverlay.pause(0);
      }
    });

    this.transitionTimeline.to(this.$screen.find(`.step-2 .text-bubble.introduction, .step-2 .actions-container`),
      {
        autoAlpha: 0,
      });

    this.transitionTimeline.to(this.$screen.find(`.step-2 .animation-overlay img, .step-2 .animation-overlay canvas`),
      {
        autoAlpha: 0
      },
      "-=0.5");

    this.transitionTimeline.to(this.$screen.find(`.step-2 .text-bubble.quiz-question`),
      {
        autoAlpha: 1,
      });


    this.transitionTimeline.fromTo(this.$screen.find(`.step-2 .questions-container .question-choices .choice`),
      {
        scale: 0,
        autoAlpha: 0,
      },
      {
        scale: 1,
        autoAlpha: 1,
        ease: "back.out",
        stagger: 0.05
      },
      "-=0.5");
  }

  showHandZoomAnimation(direction = "in") {
    if (direction == "in") {
      this.listenForPinchZoomIn = true;
      this.listenForPinchZoomOut = false;
    } else if (direction == "out") {
      this.listenForPinchZoomIn = false;
      this.listenForPinchZoomOut = true;
    }

    // console.log("Ready to listen for pinch. Zoom direction: ", direction, "Event: ", direction == "in" ? "pinchout" : "pinchin");

    // Handcoach animation
    // this.$screen.find(`.hand-zoom-in-animation, .hand-zoom-out-animation`).addClass("hidden");
    // this.$screen.find(`.hand-zoom-${direction}-animation`).removeClass("hidden");

    // On 20270417 - we switched to a back arrow button
    this.$screen.find(`.close-feedback`).removeClass("hidden");
  }

  hideHandZoomAnimation() {
    this.listenForPinchZoomIn = false;
    this.listenForPinchZoomOut = false;
    // this.$screen.find(`.hand-zoom-in-animation, .hand-zoom-out-animation`).addClass("hidden");

    // On 20270417 - we switched to a back arrow button
    this.$screen.find(`.close-feedback`).addClass("hidden");
  }

  onPinchOut(e, data) {
    // console.log("on pinchout", e, data)
    if (!this.listenForPinchZoomIn) {
      return;
    }
  }

  onPinchIn(e, data) {
    if (!this.listenForPinchZoomOut) {
      return;
    }

    // The only pinch-in action is this game is when we are on the feedback screen
    // On 20270417 - we switched to a back arrow button, so we map the action of this button to the pinch gesture
    this.hideFeedback()
  }

  hideFeedback() {
    this.quiz.hideFeedback();
  }

  showCamera() {
    this.$screen.find(`.camera-canvas`).show();
  }

  hideCamera() {
    this.$screen.find(`.camera-canvas`).hide();
  }

  drawCameraOverlays() {
    if (!this.enableCameraOverlay) {
      return
    }
  }

  resetStep1() {

  }

  resetStep2() {
    this.$screen.find(`.step-2`).removeClass("quiz-active");
    this.$screen.find(`.step-2 .actions-container`).addClass("hidden");

    this.lottieDiscoverMoreButtons.fr.pause(0);
    this.lottieDiscoverMoreButtons.en.pause(0);
    this.lottieDiscoverMoreOverlay.pause(0);
  }

  killTimeline(tl) {
    if (tl) {
      tl.pause();
      tl.seek(0);
      tl.kill()
      tl = null;
    }
  }

  reset() {
    if (!this.started) {
      return;
    }

    super.reset();

    this.currentStep = 1;

    this.hideCamera();

    // Reset step 1
    this.resetStep1();
    this.resetStep2();

    this.quiz.reset();

    if (this.transitionTimeline) {
      this.transitionTimeline.revert();
      this.transitionTimeline = null;
    }

    this.$screen.find(`.step`).removeClass("active");

    gsap.set(this.$screen.find(`.seve-cta-container`), {autoAlpha: 0});

    this.hideHandZoomAnimation();

    if (this.step1Timeout !== null) {
      clearTimeout(this.step1Timeout);
      this.step1Timeout = null;
    }

    if (this.step2Timeout !== null) {
      clearTimeout(this.step2Timeout);
      this.step2Timeout = null;
    }

    // Clear all the transforms on the steps so they'll go back to initial state
    gsap.set(this.$screen.find(`.step`), {clearProps: "all"});
  }

}
